/**
 * Maps to the backend's concept of permissions, is the same general idea!
 */
export enum Permission {
  DataMasking_Read_ProfanityAndName = 'DataMasking.Read.ProfanityAndName',
  DataMasking_Read_Sensitive = 'DataMasking.Read.Sensitive',
  ApplicationRegistration_Manage_CustomerCentreStage = 'ApplicationRegistration.Manage.CustomerCentreStage',
}
